import React, { useEffect } from "react";
import "./timer.css";

const Timer = ({ timeLeft, setTimeLeft, onTimerEnd }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1000) {
          clearInterval(interval); // Stop the timer when it ends
          onTimerEnd(true); // Notify that the timer has ended
          return 0;
        }
        return prevTime - 1000; // Decrease by 1 second
      });
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [setTimeLeft, onTimerEnd]);

  const formatTime = (time) => {
    const seconds = Math.floor(time / 1000) % 60;
    const minutes = Math.floor(time / 60000);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="timer_display">
      {timeLeft > 0 && `Resend OTP in ${formatTime(timeLeft)}`}
    </div>
  );
};

export default Timer;
